import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { UrlMetaData } from 'src/app/_models';
import { BaseComponent } from 'src/app/_base/base.component';
import { urlExpression } from 'src/app/_configs';
import { UrlMetaService } from 'src/app/_services';

@Component({
  selector: 'app-url-thumbnails',
  templateUrl: './url-thumbnails.component.html',
  styleUrls: ['./url-thumbnails.component.scss']
})
export class UrlThumbnailsComponent extends BaseComponent implements OnInit, OnChanges {
  @Input()
  postComment: string = null;
  @Output()
  postCommentEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Input()
  isEditMode: boolean = false;
  @Input()
  isEffectOnPostComment: boolean = false;
  urlsDetails: UrlMetaData[] = [];
  urls: string[] = [];
  timeing: any = null;
  constructor(private urlMetaService: UrlMetaService) {
    super();
  }

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.postComment) {
      this.urls = [];
      this.urlsDetails = [];
      if (this.timeing) clearTimeout(this.timeing);
      this.timeing = setTimeout(() => {
        this.postCommentChanged();
      }, 2000);
    }
  }
  postCommentChanged(): void {
    this.urls = this.postComment ? this.postComment.split(urlExpression) : [];
    this.urls = this.urls.filter((item, i, a) => i === a.indexOf(item) && item.match(urlExpression));
    this.urlsDetails = [];
    if (this.urls.length > 0) this.getUrlsMetaDate();
  }
  getUrlsMetaDate() {
    this.urlMetaService.GetListMetaData(this.urls).subscribe((data: UrlMetaData[]) => {
      data.map(items =>
        this.urlsDetails.push({
          hasData: items.hasData,
          url: items.url,
          title: items.title,
          description: items.description,
          keywords: items.keywords,
          imageUrl: items.imageUrl,
          siteName: items.siteName
        })
      );
    });
  }
  goToUrl(urlIndex): void {
    window.open(this.urlsDetails[urlIndex].url, '_blank');
  }
  thumbnailRemover(thumbnailIndex: number): void {
    const commentArray: string[] = this.postComment.split(urlExpression);
    if (commentArray.find(item => item === this.urls[thumbnailIndex])) {
      if (this.isEffectOnPostComment) {
        for (let i = 0; i < commentArray.find(item => item === this.urls[thumbnailIndex]).length; i++)
          this.postComment = this.postComment.replace(this.urls[thumbnailIndex], '');
        this.postCommentEmitter.emit(this.postComment);
      }
      this.urls.splice(thumbnailIndex, 1);
      this.urlsDetails.splice(thumbnailIndex, 1);
    } else {
      this.urls = [];
      this.urlsDetails = [];
    }
  }
}
